import { constantRoutes, asyncRoutes } from "@/router";
import { formatRouter } from "@/utils/filterRouter";

const state = {
    routes: []
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.routes = routes;
        state.routes = constantRoutes.concat(routes);
    }
};

const actions = {
    setRoutes({ commit }) {
        // 过滤权限路由表
        let filterRoutes = formatRouter(
            JSON.parse(localStorage.getItem("treeList")),
            asyncRoutes,
            constantRoutes,
            asyncRoutes,
            "id"
        );
        commit("SET_ROUTES", filterRoutes);
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};